// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"5bda5ee1","228":"ca8e9e28","438":"9468ddb9","679":"67782e9e","725":"fc3aaf6d","819":"b647bba7","885":"69a128f9","938":"9590eda1","953":"db00c683"}[chunkId] + ".chunk.js";
};